/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
// import { ctrlDefaults } from '../../../../shared/form-lib';
import { ControlPropType } from '../../ctrl_proptype';
import {
  MainfieldWrapper,
  FieldWrapper,
  Field,
  // LabelWrapper,
  SubtextWrapper,
  InputWrapper,
  AddImageWrapper,
  ImgCon,
} from '../../common-field-styles';

const defaultImage = 'https://storage.googleapis.com/fplsblog/add_image.svg';

const AddImage = ({ ctrl }) => {
  return (
    <MainfieldWrapper>
      <FieldWrapper>
        <Field>
          {/* <LabelWrapper required={ctrl.props.required}>{ctrl.props.label || ctrlDefaults()[ctrl.type]}</LabelWrapper> */}

          <InputWrapper>
            <AddImageWrapper className={ctrl.props.placement}>
              <ImgCon>
                {/* <LazyLoad height={150} className="animate-lazyloader"> */}
                <img
                  src={ctrl.props.upload_image ? ctrl.props.upload_image : defaultImage}
                  alt="media_image"
                />
                {/* </LazyLoad> */}
              </ImgCon>
            </AddImageWrapper>
          </InputWrapper>

          <SubtextWrapper id="descriptive text">{ctrl.props.subtext}</SubtextWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

AddImage.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};
export default AddImage;
